/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_PermissionType } from './models_PermissionType';
import type { shared_FlexibleDate } from './shared_FlexibleDate';
export type relationships_CreateChildContactRelationshipRequest = {
    contactId: string;
    /**
     * HasCustody records custody (Sorgerecht); omitted means unknown.
     */
    hasCustody?: boolean;
    permissions?: Array<models_PermissionType>;
    relationshipType: relationships_CreateChildContactRelationshipRequest.relationshipType;
    validFrom?: shared_FlexibleDate;
    validTo?: shared_FlexibleDate;
};
export namespace relationships_CreateChildContactRelationshipRequest {
    export enum relationshipType {
        PARENT = 'PARENT',
        GUARDIAN = 'GUARDIAN',
        GRANDPARENT = 'GRANDPARENT',
        SIBLING = 'SIBLING',
        AUNT_UNCLE = 'AUNT_UNCLE',
        STEP_PARENT = 'STEP_PARENT',
        FOSTER_PARENT = 'FOSTER_PARENT',
        FAMILY_FRIEND = 'FAMILY_FRIEND',
        NANNY = 'NANNY',
        OTHER = 'OTHER',
        AUPAIR = 'AUPAIR',
        BABYSITTER = 'BABYSITTER',
        COUSIN = 'COUSIN',
        GODMOTHER_GODFATHER = 'GODMOTHER_GODFATHER',
        GREAT_AUNT_UNCLE = 'GREAT_AUNT_UNCLE',
        PEDIATRICIAN = 'PEDIATRICIAN',
        NEIGHBOR = 'NEIGHBOR',
    }
}

